/*Bug #603 - Create a common component for Address fields - Author Jithin Kuriakose on 05Sept2021*/
import { useState, useEffect } from "react";
import {
    Wrapper,
    InputItem,
    Input,
    Col,
    Select,
    getStatesOfCountry,
    CommonInputLabel,
    Checkbox
} from "components";
import { getCountryCode, getFormFields, getKeyName } from "shared/utils/formlocalization";
import { Row } from "antd";


interface Props {
    className?: React.CSSProperties | String;
    preFix?: any;
    label?: String;
    keyName?: any;/*For saving insurance subscriber Address fields - Author Aby Joseph on 16 Sep 2021*/
    form?: any;
    needIsoCode?: boolean; /** Bug #611 @Author Linda Susan Raju @Date 11 Oct 2021 */
    onAccordionFieldChange?: any;
}

const defaultProps = {
  onAccordionFieldChange: () => { return Promise.resolve() }
};

const AddressInput = (props: Props) => {
    const [states, setStates] = useState<Array<any>>([]);
    const [countryData, setCountryData] = useState<Array<any>>([]);
    const [defaultCountryCode, setDefaultCountryCode] = useState<any>("United States");
    const [defaultCountry, setDefaultCountry] = useState<any>("US");
    // const [defaultStates, setDefaultStates] = useState<any>("US");
    useEffect(() => {
        import("./DropDownOptions")
            .then(({ getAllCountries }) => {
                getAllCountries().then((values) => {
                    setCountryData(values);
                });
            })
            .catch((err) => { });
        setCountry("", { key: defaultCountry });
        const { form, preFix } = props;
        try {
            const fields = form?.getFieldsValue();
            if (props.preFix !== undefined) {
                if (!(fields[preFix][getKeyName(props?.keyName, 'country')])) {
                    fields[preFix][getKeyName(props?.keyName, 'country')] = defaultCountryCode
                    form.setFieldsValue(fields)
                }
            }
            else {
                fields[getKeyName(props?.keyName, 'country')] = defaultCountryCode
                form.setFieldsValue(fields)
            }
        } catch (e) { }
    }, []);

    const setCountry = (value, option) => {
        getStatesOfCountry(option.key, props.needIsoCode)/** Bug #611 @Author Linda Susan Raju @Date 11 Oct 2021 */
            .then((values) => {
                setStates(values);
            })
            .catch((err) => { });
        // setStates(getStatesOfCountry(option.key));
    };

    const formFields = getFormFields(getCountryCode(), "address");
    return (
        <Wrapper>
            <CommonInputLabel label={props?.label} />
            {formFields.map((field, index) => (
                <Col
                    lg={field?.columnSize ? field.columnSize : 6}
                    md={6}
                    sm={12} 
                    key={index}
                >
                    <InputItem
                        name={
                            props?.preFix
                                ? [props.preFix, getKeyName(props?.keyName, field?.key)]
                                : getKeyName(props?.keyName, field?.key)/*For saving insurance subscriber Address fields - Author Aby Joseph on 16 Sep 2021*/
                        }
                        label={field?.label ? field.label : ""}
                        rules={field?.rules ? [...field.rules, { validator: props.onAccordionFieldChange }] : ""}
                    >
                        {field?.key === "state" ? (
                            <Select showSearch placeholder={ field?.placeholder ? field.placeholder : ""}>
                                {states}
                            </Select>
                        ) : field?.key === "country" ? (
                            <Select
                                // defaultValue={defaultCountryCode}
                                onSelect={setCountry}
                                showSearch
                                placeholder={ field?.placeholder ? field.placeholder : ""}
                            >
                                {countryData}
                            </Select>
                        ) : (
                            <Input
                                type="text"
                                className="form-control"
                                placeholder={
                                    field?.placeholder ? field.placeholder : ""
                                }
                            />
                        )}
                    </InputItem>
                </Col>
            ))}
        </Wrapper>
    );
};

AddressInput.defaultProps = defaultProps;
export default AddressInput;

/** End Bug #603**/
